import { SET_IP_ADDRESS } from '@/utils/store/mutationTypes'
import requestIp from 'request-ip'

export default ({ app, store }) => {
  if (process.server) {
    store.commit(`auth/${SET_IP_ADDRESS}`, { ipAddress: requestIp.getClientIp(app.context.req) })
  }
}
